import moment from 'moment';
import uuid from 'uuid';

import { APP_ERROR } from './constants';

export const appError = ({
  id = uuid(),
  title = 'Unknown error',
  route = '#',
  when = moment()
} = {}) => ({
  type: APP_ERROR,
  notification: {
    id,
    title,
    route,
    type: 'error',
    when,
    read: false
  }
});
